import { combineReducers } from "redux";
import normalizedReducers from "../utils/normalized/reducers";
import { ModelType } from "./model";

function meta(state = {}, action) {
  state = normalizedReducers.metaReducer(ModelType, state, action);
  switch (action.type) {
    case `CREATE_${ModelType}`:
    case `UPDATE_${ModelType}`:
      return {
        ...state,
        activeId: action.payload.id,
      };
    default:
      return state;
  }
}

function byId(state = {}, action) {
  return normalizedReducers.byIdReducer(ModelType, state, action);
}

function allIds(state = [], action) {
  return normalizedReducers.allIdsReducer(ModelType, state, action);
}

export default combineReducers({ meta, byId, allIds });
